module.exports = __webpack_public_path__ + "img/fullscreen-exit.0b7abf19.png";